import { Injectable, computed, signal } from '@angular/core';

/**
 * How many API calls are in flight. Reads move the thin bar at the top; changes (save, submit, approve, delete)
 * block the page with a centred spinner until they finish.
 */
@Injectable({ providedIn: 'root' })
export class ApiActivity {
  private readonly reads = signal(0);
  private readonly writes = signal(0);

  readonly busy = computed(() => this.reads() > 0 || this.writes() > 0);
  readonly saving = computed(() => this.writes() > 0);

  start(write: boolean): void {
    if (write) this.writes.update((n) => n + 1);
    else this.reads.update((n) => n + 1);
  }

  end(write: boolean): void {
    if (write) this.writes.update((n) => Math.max(0, n - 1));
    else this.reads.update((n) => Math.max(0, n - 1));
  }
}
